// extracted by mini-css-extract-plugin
module.exports = {"relatedCustomer":"style_relatedCustomer__3eRBh","plusIcon":"style_plusIcon__unJqt","minusIcon":"style_minusIcon__2VgF2","copyIcon":"style_copyIcon__3gmTG"};